// TrendingDestinations.tsx
import React from 'react';

// Dummy data for destinations
const destinations = [
  {
    name: "Down South",
    image: "/images/down-south.jpg", // Replace with actual image URL
    tours: 356,
    activities: 248,
    promotion: 26, // Percentage of promotion left
    countdown: { days: 22, hours: 9, mins: 45, secs: 58 },
  },
  {
    name: "Badulla Srilanka",
    image: "/images/badulla.jpg", // Replace with actual image URL
    tours: 356,
    activities: 248,
    promotion: 15,
    countdown: { days: 12, hours: 5, mins: 20, secs: 10 },
  },
  {
    name: "sigiriya Srilanka",
    image: "/images/sigiriya.jpg", // Replace with actual image URL
    tours: 356,
    activities: 248,
    promotion: 18,
    countdown: { days: 10, hours: 4, mins: 30, secs: 5 },
  },
  {
    name: "Gall Srilanka",
    image: "/images/gall.jpg", // Replace with actual image URL
    tours: 356,
    activities: 248,
    promotion: 5,
    countdown: { days: 4, hours: 3, mins: 21, secs: 12 },
  },
  {
    name: "Matara Srilanka",
    image: "/images/matara.jpg", // Replace with actual image URL
    tours: 356,
    activities: 248,
    promotion: 30,
    countdown: { days: 5, hours: 8, mins: 13, secs: 45 },
  },
];

const TrendingDestinations = () => {
  return (
    <div className="container mx-auto p-10">
      {/* Title and Subheading */}
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold">Trending Destinations</h2>
        <p className="mt-4 text-lg text-gray-600">Most popular choices for travelers</p>
      </div>

      {/* Cards Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {destinations.map((destination, index) => (
          <div
            key={index}
            className="bg-white shadow-lg rounded-lg overflow-hidden"
          >
            {/* Image and Promotion Badge */}
            <div className="relative">
              <img
                src={destination.image}
                alt={destination.name}
                className="w-full h-56 object-cover"
              />
              <div className="absolute top-4 right-4 bg-red-600 text-white px-4 py-2 rounded-full text-sm font-semibold">
                {destination.promotion} % OFF
              </div>
            </div>

            {/* Destination Info */}
            <div className="p-6 text-center">
              <h3 className="text-xl font-semibold text-gray-800">{destination.name}</h3>
              <p className="text-gray-500 mt-2">
                {destination.tours} Tours, {destination.activities} Activities
              </p>
            </div>

            {/* Countdown Timer */}
            <div className="bg-gray-100 p-4 text-center">
              <div className="text-sm text-gray-600">Promotion ends in:</div>
              <div className="flex justify-center space-x-2 mt-2">
                <span className="text-lg font-bold">{destination.countdown.days}d</span>
                <span className="text-lg font-bold">{destination.countdown.hours}h</span>
                <span className="text-lg font-bold">{destination.countdown.mins}m</span>
                <span className="text-lg font-bold">{destination.countdown.secs}s</span>
              </div>
            </div>

            {/* View More Button */}
            <div className="text-center py-4">
              <a
                href="#"
                className="bg-green-500 text-white px-6 py-2 rounded-lg font-semibold hover:bg-green-600"
              >
                View More
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrendingDestinations;
